<template>
  <header class="site__header" v-if="showHeader || isSpam">
    <template v-if="showProfileImage">
      <img
        class="site__profile-img"
        :class="{
          'site__profile-img--has-border': campsite.site_profile_image_border,
        }"
        :src="profileImageUrl"
        :alt="`${user.first_name} Profile Picture`"
        height="100"
        width="100"
        v-if="isEnabled"
      />
      <div class="site__profile-img" v-else />
    </template>
    <h1 class="site__username" :class="{ 'sr-only': hideTitle && !isSpam }">
      {{ siteTitle }}
    </h1>
    <p
      class="site__intro"
      v-if="campsite.site_intro_text && !isSpam && isEnabled"
    >
      {{ campsite.site_intro_text }}
    </p>
  </header>
  <h1 class="sr-only" v-else>{{ siteTitle }}</h1>
</template>

<script>
import { convertImageUrlToEncodedUrl } from '@campsite-bio/component-lib';

export default {
  props: {
    isEnabled: Boolean,
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    isSpam() {
      return this.user.spam;
    },

    campsite() {
      return this.$store.state.campsite;
    },

    profileImageUrl() {
      return convertImageUrlToEncodedUrl(this.campsite.profile_image, 200);
    },

    siteTitle() {
      if (!this.isEnabled) return 'This profile is coming soon...';
      if (this.campsite.site_intro_title) return this.campsite.site_intro_title;
      return `@${this.campsite.username}`;
    },

    hideTitle() {
      return this.campsite.site_hide_intro_title;
    },

    showProfileImage() {
      return !this.campsite.site_hide_profile_image;
    },

    showHeader() {
      return (
        !this.campsite.site_hide_profile_image ||
        !this.campsite.site_hide_intro_title ||
        this.campsite.site_intro_text
      );
    },
  },
};
</script>

<style lang="scss">
.site__header {
  text-align: center;
  padding-top: 30px;
  position: relative;
}

.site__profile-img {
  background: #fff;
  border: none;
  border-radius: 50%;
  height: 100px;
  margin-bottom: 5px;
  width: 100px;
  object-fit: cover;

  &--has-border {
    border: 2px solid var(--p-image-border-color);
  }
}

div.site__profile-img {
  background: #ccc;
  display: inline-block;
}

.site__username {
  font-size: 22px;
  color: var(--p-title-color);
  font-weight: var(--p-title-font-weight);
  font-family: var(--p-title-font-family);
  line-height: 1.25;
  margin: 5px 0;
}

.site__intro {
  font-weight: 400;
  font-size: 0.925rem;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 450px;
}
</style>
